export const fullBlack = "#000000"
export const contrastGrey = "#333333" 
export const black = "#212721";
export const blue = "#041E42";
export const orange = "#BE531C";
export const coolGrey = "#D9D9D6";
export const grey = "#AEA8A5";
export const pearlWhite = "#D9D9D6"
export const sand = "#AEA8A5"
export const white = "#FFFFFF"
export const Colors = {
  blue: {
          name: "Blue Pininfarina",
          hex: blue,
        contrastHex: white
      },
  orange: {
          name: "Arancione",
          hex: orange,
          contrastHex: white,
      },
      fullBlack:{
          name: "Full Nero",
          hex: fullBlack,
          contrastHex: white
      },
  black: {
          name: "Nero",
          hex: black,
          contrastHex: white
      },
  silver: {
          name: "Argento",
          hex: coolGrey,
          contrastHex: white
      },
  pearl_white: {
          name: "Bianco Perla",
          hex: pearlWhite,
          contrastHex: contrastGrey,
      },
  sand:{
          name:"Sabbia",
          hex: sand,
          contrastHex:white
        }
  }

